// src/components/RequireAdmin.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAdmin() {
  const location = useLocation();

  // 🔒 1. No autenticado
  const { user, initialized } = useAuth();

    // 🧠 1.1 esperar validación real
      if (!initialized) {
       return null;
      }

    // 🔒 1.2. usuario no válido
      if (!user) {
       return <Navigate to="/login" state={{ from: location }} replace />;
      }

  // 🔒 2. No es admin
  const allowedRoles = ["ADMIN", "STAFF"];

    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/" replace />;
    }

  // ✅ 3. Es admin
  return <Outlet />;
}
